import {
  SET_COUPON_LIST,
  SET_COUPON_NO,
  SET_IS_DISTRIBUTE,
  SET_USE_INTEGRAL,
} from '@/action-types/shopping-car'
interface Action {
  type: string
  coupon_list: Array<any>
  coupon_no: string
  is_distribute: boolean
  use_integral: boolean
}
const initDepotState = {
  coupon_list: [],
  is_distribute: false,
  use_integral: false,
}
const shoppingCar = (state = initDepotState, action: Action) => {
  switch (action.type) {
    case SET_COUPON_LIST:
      return Object.assign({}, state, { coupon_list: action.coupon_list })
    case SET_COUPON_NO:
      return Object.assign({}, state, { coupon_no: action.coupon_no })
    case SET_IS_DISTRIBUTE:
      return Object.assign({}, state, { is_distribute: action.is_distribute })
    case SET_USE_INTEGRAL:
      return Object.assign({}, state, { use_integral: action.use_integral })
    default:
      return state
  }
}
export { shoppingCar }
